export const serviceDateLabel = 'service date';
export const updateServiceDateButton = 'update service date';
export const editServiceDateModalTitle = 'Edit service date';
export const editServiceDateModalDescription = 'Choose a new date for this service.';
export const serviceDatePickerPlaceholder = 'MM/DD/YY...';
export const serviceDateSuccess = 'Successfully changed service date';
export const serviceDateHover = 'edit service date';
